import styled, { css } from 'styled-components';
import { FontMixin, AlignmentMixin } from '../../Space/styled';
import { BorderType, ListStyleType } from '../../../../types/space';

const SharedMixin = css`
  display: table;
  min-width: 100%;
  border-collapse: collapse;
`;

const TableFontsMixin = (headingStyle: any, rowStyle: any) => css`
  & > thead > tr > th > div {
    ${AlignmentMixin(headingStyle)}
  }
  & > thead > tr > th {
    ${FontMixin(headingStyle)}
  }
  & > tbody > tr > td > div {
    ${AlignmentMixin(rowStyle)}
  }
  & > tbody > tr > td > div > span {
    ${FontMixin(rowStyle)}
  }
`;

interface IProps {
  headingStyle: any;
  rowStyle: any;
}

export const TableBorderAll = styled.table<IProps>`
  ${SharedMixin}
  border: 1px solid #333333;

  & > tbody > tr > td,
  & > thead > tr > th {
    border: 1px solid #333333;
  }
  & > thead > tr > th {
    border-bottom: 2px solid #333333;
  }

  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const TableBorderHeading = styled.table<IProps>`
  ${SharedMixin}

  & > thead > tr > th {
    border-bottom: 2px solid #333333;
  }
  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const TableBorderHorizontal = styled.table<IProps>`
  ${SharedMixin}
  & > thead > tr > th {
    border-bottom: 2px solid #333333;
  }
  & > thead > tr:not(:last-child) {
    border-bottom: 1px solid #333333;
  }

  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const TableBorderInner = styled.table<IProps>`
  ${SharedMixin}

  & > thead > tr:not(:last-child) {
    border-bottom: 1px solid #333333;
  }
  & > thead > tr > th {
    border-bottom: 2px solid #333333;
  }
  & > thead > tr > th:not(:last-child),
  & > tbody > tr > td:not(:last-child) {
    border-right: 1px solid #333333;
  }
  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const TableBorderVertical = styled.table<IProps>`
  ${SharedMixin}

  & > thead > tr > th:not(:last-child),
  & > tbody > tr > td:not(:last-child) {
    border-right: 1px solid #333333;
  }
  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const TableBorderNone = styled.table<IProps>`
  ${SharedMixin}
  ${(props) => TableFontsMixin(props.headingStyle, props.rowStyle)}
`;

export const BORDER_COMPONENT: { [key in BorderType]?: string } = {
  [BorderType.All]: TableBorderAll,
  [BorderType.Heading]: TableBorderHeading,
  [BorderType.Horizontal]: TableBorderHorizontal,
  [BorderType.Inner]: TableBorderInner,
  [BorderType.Vertical]: TableBorderVertical,
  [BorderType.None]: TableBorderNone,
};

const ListFontsMixin = (rowStyle: any) => css`
  & > li,
  & > li > div > div > span,
  & > div > div > div > span {
    ${FontMixin(rowStyle)}
  }
`;

interface IListProps {
  rowStyle: any;
}
export const ListOrdered = styled.ol<IListProps>`
  padding-left: 25px;
  margin: 0;
  ${(props) => ListFontsMixin(props.rowStyle)}
`;

export const ListUnordered = styled.ul<IListProps>`
  padding-left: 25px;
  margin: 0;
  & > li {
    list-style: disc;
  }
  ${(props) => ListFontsMixin(props.rowStyle)}
`;

export const ListNone = styled.div<IListProps>`
  padding-left: 5px;
  margin: 0;
  & > table {
    margin-left: -2.5px;
  }
  ${(props) => ListFontsMixin(props.rowStyle)}
`;

export const LIST_COMPONENT: { [key in ListStyleType]?: string } = {
  [ListStyleType.None]: ListNone,
  [ListStyleType.Bullets]: ListUnordered,
  [ListStyleType.Numbers]: ListOrdered,
};
